// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  width: 220px;
  height: 100%;
  background: url('bg-noise.662e9a7b0a65a925.png');
  color: var(--primaryTextColor);
}
nav button.burger {
  height: 100%;
}

.titre {
  font-family: var(--font-bnp);
}
.titre h2 {
  text-transform: uppercase;
  margin: 0;
  font-weight: 300;
  font-size: 1.2rem;
}
.titre .location {
  font-size: 0.9rem;
  font-weight: 200;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
